<template>
  <div class="hide-content">
    <img src="@/assets/images/my-quiz-answer/empty-answers.svg">
    <p>
      {{ $t('review_all_questions') }}
    </p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.hide-content {
  text-align: center;
  padding-top: 24px;
  color: var(--base-90, #313131);

  p {
    margin-top: 16px;
    font-size: 16px;
  }
}
</style>
